import { UserAreaBoundary } from "@/components/UserAreaBoundary";
import { Page } from "@/components/layout/Page";
import { WidgetWithQueryParameters } from "@/components/layout/WidgetFrame/widget.types";
import { FeedingSection } from "@/pages/DashboardPage/fms/sections/FeedingSection";
import { ManagementSoftwareSection } from "@/pages/DashboardPage/fms/sections/ManagementSoftwareSection";
import { MilkingSection } from "@/pages/DashboardPage/fms/sections/MilkingSection";
import { ProactiveSupportSection } from "@/pages/DashboardPage/fms/sections/ProactiveSupportSection";

type Props = WidgetWithQueryParameters<"dateFrom" | "dateTo">;

export function FMSSubpage({ queryParameters }: Props) {
    return (
        <Page.Content.Sections>
            <UserAreaBoundary areas={["ConnectionPerformanceDeviceIndex"]} allowDeveloperMode={true}>
                <ProactiveSupportSection />
            </UserAreaBoundary>
            <MilkingSection queryParameters={queryParameters} />
            <FeedingSection queryParameters={queryParameters} />
            <ManagementSoftwareSection queryParameters={queryParameters} />
        </Page.Content.Sections>
    );
}
